import Nazvy from "../Nazvy";
import Hodnota from "../Hodnota";
import Tooltip from "@mui/material/Tooltip";

const ConfigTabulka = ({
  tabulka,
  cisloHlavnejTab,
  classPreTabulka,
  stlacene,
  slovnik,
  selectedLanguage,
  nevybrateMoznosti,
  najdene,
  najdenePopis,
  poznamka,
  updateKtoraTab,
  zakaznicke,
  updateZakaznicke,
  idPreTabulku,
  onHandleClick,
}) => {
  return tabulka.map((hodnotaArray, indexTabulky) => {
    const handleHover = (i) => {
      updateKtoraTab(i);
    };

    const handleX = (e, index) => {
      const nextCounters = zakaznicke.map((c, i) => {
        if (i === index) {
          // Increment the clicked counter
          return e.target.value;
        } else {
          // The rest haven't changed
          return c;
        }
      });
      updateZakaznicke(nextCounters);
    };

    function countConsecutiveKrat(arr) {
      let count = 0;

      for (let i = 0; i < arr.length; i++) {
        if (arr[i] === "*") {
          count++;
        } else {
          break; // exit the loop when a different element is encountered
        }
      }

      return count + 1;
    }

    function removeLastPeriod(str) {
      // Check if the last character is a period
      if (str.charAt(str.length - 1) === ".") {
        // Remove the last character using slice
        return str.slice(0, -1);
      } else {
        // If the last character is not a period, return the original string
        return str;
      }
    }

    return (
      <div
        hidden={
          nevybrateMoznosti &&
          stlacene[cisloHlavnejTab].toLocaleLowerCase() !== "x"
            ? true
            : false
        }
      >
        <div id={idPreTabulku + indexTabulky} className={classPreTabulka}>
          <Nazvy
            tabulkaIteracia={hodnotaArray}
            prekladac={slovnik}
            jazyk={selectedLanguage}
            farba={stlacene[cisloHlavnejTab]}
            nevybrateMoznosti={nevybrateMoznosti}
            poznamka={poznamka}
          />

          <div className="table-content">
            {" "}
            {hodnotaArray.hodnoty.map((hodnota, indexRiadka) => {
              let indexy = cisloHlavnejTab;
              // check ci cena
              let momentalny_kod = Number.isInteger(hodnota[hodnota.length - 1])
                ? hodnota[hodnota.length - 2]
                : hodnota[hodnota.length - 1];
              let znenieVynimky = null;
              if (najdene && najdene[indexy].includes(momentalny_kod)) {
                znenieVynimky =
                  najdenePopis[indexy][najdene[indexy].indexOf(momentalny_kod)];
              }
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    alignItems: "center",
                  }}
                >
                  <Tooltip
                    title={
                      znenieVynimky
                        ? slovnik.hasOwnProperty(
                            removeLastPeriod(znenieVynimky)
                          )
                          ? selectedLanguage === "EN"
                            ? slovnik[removeLastPeriod(znenieVynimky)][0] + "."
                            : selectedLanguage === "RU"
                            ? slovnik[removeLastPeriod(znenieVynimky)][1] + "."
                            : znenieVynimky
                          : znenieVynimky
                        : ""
                    }
                    placement="right"
                    arrow
                  >
                    <div
                      key={indexy.toString() + indexRiadka}
                      onClick={() => {
                        onHandleClick(
                          hodnota,
                          indexy,
                          indexTabulky,
                          indexRiadka
                        );
                      }}
                      onMouseOver={() => handleHover(indexy)}
                      className={
                        najdene && najdene[indexy].includes(momentalny_kod)
                          ? "nemozes table-row"
                          : momentalny_kod === stlacene[indexy]
                          ? "stisknute table-row"
                          : "nestisknute table-row"
                      }
                    >
                      {/* Logika pre spajanie pri KRAT */}
                      {hodnota.map((hodnotaRiadok, indexHodnoty) => {
                        if (hodnota.length - 1 !== indexHodnoty) {
                          // dalsia hodnota ma * vypocitat flex
                          if (
                            hodnota[indexHodnoty + 1] === "*" &&
                            hodnotaRiadok !== "*"
                          ) {
                            const velkostFlexu = countConsecutiveKrat(
                              hodnota.slice(indexHodnoty + 1)
                            ).toString();

                            return (
                              <Hodnota
                                hodnotaRiadok={hodnotaRiadok}
                                slovnik={slovnik}
                                selectedLanguage={selectedLanguage}
                                poznamka={poznamka}
                                velkostFlexu={velkostFlexu}
                              />
                            );
                          } else if (hodnotaRiadok !== "*") {
                            return (
                              <Hodnota
                                hodnotaRiadok={hodnotaRiadok}
                                slovnik={slovnik}
                                selectedLanguage={selectedLanguage}
                                poznamka={poznamka}
                              />
                            );
                          } else return null;
                        } else if (hodnotaRiadok !== "*") {
                          return (
                            <Hodnota
                              hodnotaRiadok={hodnotaRiadok}
                              slovnik={slovnik}
                              selectedLanguage={selectedLanguage}
                              poznamka={poznamka}
                            />
                          );
                        } else return null;
                      })}
                    </div>
                  </Tooltip>
                  {indexRiadka !== hodnotaArray.hodnoty.length - 1 &&
                    hodnotaArray.hodnoty[indexRiadka + 1][0] !== hodnota[0] &&
                    (cisloHlavnejTab === 2 || cisloHlavnejTab === 4) && (
                      <div
                        style={{
                          backgroundColor: "#73ADD3",
                          height: "1px",
                          border: "0.5px solid #73ADD3",
                          borderRadius: "25px",
                          width: "95%",
                          marginTop: "2px",
                          marginBottom: "12px",
                        }}
                      ></div>
                    )}
                </div>
              );
            })}
          </div>
        </div>
        {(nevybrateMoznosti ||
          (zakaznicke && zakaznicke[cisloHlavnejTab].length > 0)) &&
          indexTabulky === tabulka.length - 1 && (
            <>
              <div className="poznamka-x">
                {selectedLanguage === "EN"
                  ? "Additional notes on configurations, questions:"
                  : selectedLanguage === "RU"
                  ? "Дополнительные замечания по конфигурациям, вопросы:"
                  : "Doplňujúce poznámky ku konfigurácií, otázky:"}
              </div>
              <div
                className={
                  "X" === stlacene[cisloHlavnejTab]
                    ? "stisknute table-row-x"
                    : "nestisknute table-row-x"
                }
                onMouseOver={() => handleHover(cisloHlavnejTab)}
                onClick={() => {
                  onHandleClick("X", cisloHlavnejTab, 0);
                }}
              >
                <input
                  className="table-data-zakaznicke"
                  placeholder={
                    selectedLanguage === "EN"
                      ? "Enter the desired specification here ..."
                      : selectedLanguage === "RU"
                      ? "Введите здесь желаемую спецификацию ..."
                      : "Sem zadajte požadovanú špecifikáciu ..."
                  }
                  value={zakaznicke[cisloHlavnejTab]}
                  onChange={(e) => handleX(e, cisloHlavnejTab)}
                ></input>
                <div className="table-data-zakaznicke">X</div>
              </div>
            </>
          )}
      </div>
    );
  });
};

export default ConfigTabulka;
